import React, {useState, useEffect} from 'react';
import './NotificationPopup.css';

const NotificationPopup = ({
  message,
  type = 'info',
  onClose,
  duration = 3000,
}) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      if (onClose) onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  return (
    <div
      className={`notification-popup notification-popup_type_${type} ${
        visible ? 'notification-popup_visible' : ''
      }`}
    >
      <span className='notification-popup__message'>{message}</span>
      <button
        className='notification-popup__close'
        onClick={() => setVisible(false)}
      >
        ×
      </button>
    </div>
  );
};

export default NotificationPopup;
